export default "__VITE_ASSET__d340221a__"